export default "__VITE_ASSET__szgT9$2c__"